var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("textarea", {
    directives: [
      {
        name: "model",
        rawName: "v-model",
        value: _vm.innerValue,
        expression: "innerValue",
      },
    ],
    attrs: { rows: _vm.rows },
    domProps: { value: _vm.innerValue },
    on: {
      input: function ($event) {
        if ($event.target.composing) return
        _vm.innerValue = $event.target.value
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }